import { render, staticRenderFns } from "./agentur-duplicates-merge-modal.vue?vue&type=template&id=9a065bd6"
import script from "./agentur-duplicates-merge-modal.vue?vue&type=script&lang=js"
export * from "./agentur-duplicates-merge-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports